module.exports = __webpack_public_path__ + "img/open_menu.fb606968.svg";